module.exports = __webpack_public_path__ + "img/20191016163234475.cc4b8fc4.jpg";